module.exports = __webpack_public_path__ + "static/media/obstacleActiveIcon.e2ccf62e.svg";